// Show the OOS alternatives strip when the selected OPTION is sold out.
//
// Loaded only on dropdown ("config") products — oos-alternatives.liquid emits
// the <script> tag only in option mode. The strip's cards are product-level
// data and identical whichever option is selected, so this module never
// re-renders anything: it toggles one `hidden` attribute and writes the two
// attribution values the snippet's own stamping script reads back.
//
// shouldShow() and stripState() are MIRRORED in tests/oos-alts-variant.mjs and
// compared byte-for-byte by the drift guard there. Edit both or neither.
(function () {
  'use strict';

  var root = null;
  var payload = null;

  function shouldShow(variantId, availability) {
    if (!variantId) return false;
    if (!availability) return false;
    var key = String(variantId);
    if (!Object.prototype.hasOwnProperty.call(availability, key)) return false;
    return availability[key] === false;
  }

  function stripState(variantId, data) {
    var availability = data && data.availability;
    var show = shouldShow(variantId, availability);
    if (!show) return { show: false, variantId: '', sku: '' };
    var key = String(variantId);
    var skus = (data && data.skus) || {};
    var sku = Object.prototype.hasOwnProperty.call(skus, key) ? skus[key] : '';
    return { show: true, variantId: key, sku: typeof sku === 'string' ? sku : '' };
  }

  function readPayload() {
    var el = document.getElementById('oos-alts-variant-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // The product form's [name="id"] is the authority on what is selected: it is
  // what would actually go in the basket. There are TWO /cart/add forms on a
  // PDP — the second is Shopify's installment widget — so resolve through
  // <product-form> rather than a bare querySelector on the action.
  function selectedVariantId() {
    var form = document.querySelector('product-form form[action*="/cart/add"]');
    var input = form && form.querySelector('[name="id"]');
    return input ? input.value : '';
  }

  // Idempotent: writes only when the DOM has actually drifted, so it is safe to
  // call repeatedly on a timer without flickering the strip.
  function apply() {
    if (!root || !payload) return;
    var state = stripState(selectedVariantId(), payload);
    if (state.show) {
      if (root.hasAttribute('hidden')) root.removeAttribute('hidden');
      if (root.dataset.oosSoldOutVariant !== state.variantId) {
        root.dataset.oosSoldOutVariant = state.variantId;
      }
      if (root.dataset.oosSoldOutSku !== state.sku) {
        root.dataset.oosSoldOutSku = state.sku;
      }
    } else {
      if (!root.hasAttribute('hidden')) root.setAttribute('hidden', '');
      // Removed, not blanked. A stale id left behind would be stamped onto the
      // next ordinary add-to-cart as a rescue that never happened.
      if ('oosSoldOutVariant' in root.dataset) delete root.dataset.oosSoldOutVariant;
      if ('oosSoldOutSku' in root.dataset) delete root.dataset.oosSoldOutSku;
    }
  }

  // ── Holding the decision against the theme's late re-render ──────────────
  //
  // ProductInfo.renderProductInfo() (assets/theme.js:1471) fetches the section
  // and copies specific ids back into the page. The strip is not one of them,
  // so the container itself survives — but that same re-render was measured on
  // the developer substitute putting a stale variant back into [name="id"] at
  // about +1200ms, long after a one-shot handler had already run. An <input>'s
  // .value is a PROPERTY, so that write emits no MutationRecord and an observer
  // cannot catch it either.
  //
  // So the decision is re-asserted over a BOUNDED window after each change
  // rather than fired once. Bounded, so it can never become a permanent timer
  // fighting the theme.
  var timer = null;
  var until = 0;

  function settle() {
    apply();
    if (Date.now() > until) {
      clearInterval(timer);
      timer = null;
    }
  }

  function schedule() {
    apply();
    until = Date.now() + 2500;
    if (timer) return;
    timer = setInterval(settle, 150);
  }

  function init() {
    root = document.querySelector('.oos-alts[data-oos-alts-mode="option"]');
    if (!root) return;
    payload = readPayload();
    if (!payload) return;

    // Correct on landing, including a ?variant= that points straight at a
    // sold-out option, before any change event has fired.
    schedule();

    // Delegated from document: the theme replaces parts of the section on a
    // variant change, so a listener bound directly to the <select> would not
    // survive it.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList
          && e.target.classList.contains('single-option-selector')) schedule();
    });

    // Guarded exactly as sections/quick-view.liquid:443 guards them — both are
    // top-level declarations in assets/vendor.js, i.e. script-scoped globals
    // that exist only if that file loaded first.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.variantChange, schedule);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
